module.exports = __webpack_public_path__ + "static/media/placeholder.f771455e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/placeholder.jpg
// module id = 1239
// module chunks = 0